import React, {useCallback, useRef, useState} from 'react'
import {withTranslation} from "react-i18next";
import {LoadingOutlined} from '@ant-design/icons'

import MODES from 'constants/MODES'
import useSearchContext from 'components/SearchContext/useSearchContext'
import BButton from 'components/Form/Fields/BButton'
import Product from 'components/ProductsList/Product'
import Suggestions from 'components/ProductsList/Suggestions'
import Categories from 'components/ProductsList/Categories'
import requestHandler from 'utils/requestHandler'

const tmpCount = 42

const ProductListLoaded = ({t, items, loadMoreRequest, setData, handleSearch, searchValue, resultsHeading}) => {
  const {mode} = useSearchContext()

  const [loadingMore, setLoadingMore] = useState(false)

  const page = useRef(0)

  const handleLoadMore = useCallback(e => {
    e.preventDefault()
    setLoadingMore(true)
    requestHandler(() => loadMoreRequest(page.current + 1), 'json')
      .then(r => {
        if (r.success) {
          setData(({items}) => ({items: {...items, metaProduct: {...items.metaProduct, ...r.data.items.metaProduct}}}))
          page.current = page.current + 1
        }
        setLoadingMore(false)
      })
  }, [setData, loadMoreRequest])

  return (
    <div className='productsList'>
      {items.metaProduct ? (
        <>
          {mode === MODES.fullSearchResults ? (
            <h1 className='productsList-fullSearchResultsHeading'>{t('You\'re looking for')} <b>"{searchValue}"</b></h1>
          ) : mode === MODES.categoryItems ? (
            <>
              <h1 className='productsList-fullSearchResultsHeading'>{resultsHeading ?? <LoadingOutlined/>}</h1>
              <h3 className='productsList-secondaryHeading'>
                <b>{tmpCount ?? <LoadingOutlined/>} {t('products')}</b> {t('in this category')}
              </h3>
            </>
          ) : (
            <Suggestions t={t} suggestions={items.suggestions} handleSearch={handleSearch} searchValue={searchValue}/>
          )}

          {items.categories && (
            <Categories t={t} categories={items.categories} mode={mode} searchValue={searchValue}/>
          )}

          <div className='productsList-theList'>
            {mode === MODES.autocomplete && <h4>We found products</h4>}
            <div>
              {Object.keys(items.metaProduct).map(e => <Product key={e} metaProduct={items.metaProduct[e]}/>)}
            </div>
            {loadingMore ? 'loading more...' : <BButton onClick={handleLoadMore}>Load more...</BButton>}
          </div>
        </>
      ) : (
        'no items found'
      )}
    </div>
  )
}

export default withTranslation()(ProductListLoaded)
